export type BdPatientClinicalComplexityLevel = 0 | 1 | 2 | 3 | 4 | 5 | 6;

const PATIENT_CLINICAL_COMPLEXITY_LEVEL_DISPLAY_NAMES = {
  0: 'keine Komplikation oder Komorbidität (0)',
  1: 'leichte Komplikation oder Komorbidität (1)',
  2: 'mäßig schwere Komplikation oder Komorbidität (2)',
  3: 'schwere Komplikation oder Komorbidität (3)',
  4: 'äußerst schwere Komplikation oder Komorbidität (4)',
  5: 'äußerst schwere Komplikation oder Komorbidität (5)',
  6: 'äußerst schwere Komplikation oder Komorbidität (6)',
} as const;

export const BD_PATIENT_CLINICAL_COMPLEXITY_LEVEL_DISPLAY_NAMES: {
  [pccl in BdPatientClinicalComplexityLevel]: string;
} = PATIENT_CLINICAL_COMPLEXITY_LEVEL_DISPLAY_NAMES;

export type PcclDisplayName =
  (typeof PATIENT_CLINICAL_COMPLEXITY_LEVEL_DISPLAY_NAMES)[keyof typeof PATIENT_CLINICAL_COMPLEXITY_LEVEL_DISPLAY_NAMES];
